/**
 * Submittal Log badge.
 * Design: 36×36 container (#ACADFF) + dual-folder glyph (#4448C1).
 */
export default function SubmittalLogCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#ACADFF" />
      <path
        d="M12 13V10C12 9.44772 12.4477 9 13 9H19.4142L21.4142 11H27C27.5523 11 28 11.4477 28 12V22C28 22.5523 27.5523 23 27 23H24V26C24 26.5523 23.5523 27 23 27H9C8.44772 27 8 26.5523 8 26V14C8 13.4477 8.44772 13 9 13H12ZM12 15H10V25H22V23H12V15ZM14 11V21H26V13H20.5858L18.5858 11H14Z"
        fill="#4448C1"
      />
    </svg>
  );
}
